import React, { useEffect } from "react";
import "./Seva_Logbook_Details.css";
import Pink_Btn from "../common/common_btn/pink_btn/Pink_Btn";
import { useNavigate, useParams } from "react-router-dom";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import { useDispatch, useSelector } from "react-redux";
import { GetSingle } from "../../features/admin/volunteerdetail/volunteer/Slice";
import { IDS } from "../../utils/IDS";
import { decodeId, formatDate } from "../../utils/common";


// ⭐ Move helpers OUTSIDE component (performance)
const getFullAddress = (centre) => {
  if (!centre) return "Address not available";

  return [
    centre?.address,
    centre?.Area?.name,
    centre?.City?.name,
    centre?.State?.name,
    centre?.Country?.name,
    centre?.Pincode?.name,
  ]
    .filter(Boolean)
    .join(", ");
};



const Seva_Logbook_Details = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ✅ Get single volunteer from redux
  const volunteer = useSelector((state) => state.volunteers?.single);

  useEffect(() => {
    if (id) {
      dispatch(GetSingle(decodeId(id)));
    }
  }, [dispatch, id]);

  // ✅ Loading guard
  if (!volunteer) return null;

  // ⭐ Extract nested objects ONCE
  const detail = volunteer?.Volunteers_Detail;
  const volunteering = volunteer?.Volunteering;
  const centre = volunteering?.Contact_us_centre;

  // ✅ Safe image
  const image = volunteering?.image
    ? IDS.IMG_URL + volunteering.image
    : "/assets/images/default.jpg";

  // ✅ Dynamic label-value data
  const data = [
    {
      label: "Full Name of Volunteer",
      value: volunteer?.User ? `${volunteer?.User?.name}` : `${volunteer?.f_name || ""} ${volunteer?.l_name || ""}`,
    },
    {
      label: "Email",
      value: volunteer?.email || "N/A",
    },
    {
      label: "Contact Number",
      value: volunteer?.contact_no || "N/A",
    },
    {
      label: "Days of Service",
      value: detail?.Days_of_service?.name || "N/A",
    },
    {
      label: "Hours of Service",
      value: detail?.Hours_of_service?.name || "N/A",
    },
    {
      label: "How Did You Learn About This Opening?",
      value: detail?.learn_about_this_opening || "N/A",
    },
    {
      label: "Volunteering Duration",
      value: detail?.want_volunteer || "N/A",
    },
    {
      label: "Volunteered Before?",
      value: detail?.have_you_volunteered || "N/A",
    },
    {
      label: "Volunteering Start Date",
      value: formatDate(detail?.joining_date),
    },
    {
      label: "Other Skills",
      value: detail?.skills || "N/A",
    },
  ];

  return (
    <section className="Seva_Logbook_Details">
      <div className="container">

        <Common_Back_Header backNavigation={-1} />

        <div className="logobook_main_div">

          {/* Header */}
          <div className="header_div">
            <p className="title_text">Volunteer as and at:</p>
          </div>

          <div className="main_content_div">

            {/* Top Info */}
            <div className="info_div">

              <div className="img_text_div">
                <img
                  src="/assets/images/event_registration/near_by_events/user.png"
                  className="inner_img"
                />
                <p className="inner_text">
                  {detail?.Volunteer_Position?.name || "Volunteer"}
                </p>
              </div>

              <div className="img_text_div">
                <img
                  src="/assets/images/event_registration/near_by_events/location.png"
                  className="inner_img"
                />
                <p className="inner_text">
                  {getFullAddress(centre)}
                </p>
              </div>

              <div className="img_text_div">
                <img
                  src="/assets/images/event_registration/near_by_events/calendar.png"
                  className="inner_img"
                />
                <p className="inner_text">
                  {formatDate(volunteer?.createdAt)}
                </p>
              </div>

            </div>

            {/* Volunteer Details Title */}
            <div className="title_div">
              <div className="title_img_div">
                <img
                  src="/assets/images/event_registration/near_by_events/pink_user.png"
                  className="user_img"
                />
                <p className="text">Volunteer Details</p>
              </div>
            </div>

            {/* Label Values */}
            <div className="label_value_div">
              {data.map((item, index) => (
                <div className="row_div" key={index}>
                  <p className="label_text">{item.label}</p>
                  <p className="value_text">{item.value}</p>
                </div>
              ))}

              <div className="btn_holder">
                <Pink_Btn
                  btnText={"OK"}
                  onClick={() => navigate("/seva-logbook")}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Seva_Logbook_Details;
